import {
  ArrowLeft,
  CircleQuestionMark,
  ArrowRight,
  Rocket,
  Building2,
  Calendar,
  MapPin,
  FileText,
  BriefcaseBusiness,
  Camera,
  Check,
  ChevronLeft,
  CreditCard,
  Handshake,
  StickyNote,
  Info,
  CloudDownload,
  CloudUpload,
  Pencil,
  Eye,
  EyeOff,
  FolderOpen,
  ChartNoAxesCombined,
  Zap,
  MapPinned,
  LogOut,
  Mail,
  Minus,
  Users,
  User,
  Phone,
  Plus,
  Smartphone,
  Search,
  IdCard,
  ListTodo,
  Settings,
  Star,
  Waypoints,
  ThumbsDown,
  ThumbsUp,
  Trees,
  Trash,
  Globe,
  Cable,
  BarChart3,
  TextSearch,
  Map,
  Table,
  TrendingUpDown,
  MessageSquareMore,
  ChevronDown,
  ChevronsLeft,
  CheckLine,
  Link,
  ExternalLink,
  UserPlus,
  ArrowDown,
  ArrowUp,
  ChevronsUpDown,
  X,
  TriangleAlert,
  CircleCheck,
  Clock,
  CircleX,
  Archive,
  TrendingUp,
  Headphones,
  MessageSquare,
  MoreHorizontal,
  Lock,
  Video,
  ChartPie,
  ChartColumnIncreasing,
} from 'lucide-react';

import { Bess, Biogas, Hydrogen, Solar, SolarWind, Wind, Hidropower, Datacenter, Topco } from '../technologies';

import { Linkedin } from '../social/linkedin';
import { MyOffers } from '../my-offers';

const technologies = {
  'bess': Bess,
  'biogas': Biogas,
  'hydrogen': Hydrogen,
  'solar': Solar,
  'solar-wind': SolarWind,
  'wind': Wind,
  'hidropower': Hidropower,
  'datacenter': Datacenter,
  'topco': Topco,
};

const customIcons = {
  'my-offers': MyOffers,
};

const social = {
  linkedin: Linkedin,
};

export const icons = {
  ...technologies,
  ...social,
  ...customIcons,
  'archive': Archive,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'chevrons-up-down': ChevronsUpDown,
  'bar-chart3': BarChart3,
  'briefcase-business': BriefcaseBusiness,
  'buildings': Building2,
  'calendar': Calendar,
  'camera': Camera,
  'capacity-energy': Cable,
  'check': Check,
  'check-line': CheckLine,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevrons-left': ChevronsLeft,
  'circle-check': CircleCheck,
  'circle-x': CircleX,
  'clock': Clock,
  'credit-card': CreditCard,
  'download': CloudDownload,
  'edit': Pencil,
  'external-link': ExternalLink,
  'eye-open': Eye,
  'eye-off': EyeOff,
  'file-text': FileText,
  'folder-information': FolderOpen,
  'graph-bar': ChartNoAxesCombined,
  'handshake': Handshake,
  'headphones': Headphones,
  'id-card': IdCard,
  'info': Info,
  'lightning': Zap,
  'link': Link,
  'location': MapPinned,
  'lock': Lock,
  'log-out': LogOut,
  'mail': Mail,
  'map': Map,
  'map-pin': MapPin,
  'message-square': MessageSquare,
  'message-square-more': MessageSquareMore,
  'minus': Minus,
  'more-horizontal': MoreHorizontal,
  'people': Users,
  'person': User,
  'phone': Phone,
  'plus': Plus,
  'rocket': Rocket,
  'search': Search,
  'search-text': TextSearch,
  'settings': Settings,
  'smartphone': Smartphone,
  'start-rating': Star,
  'sticky-note': StickyNote,
  'table': Table,
  'thumb-down': ThumbsDown,
  'thumb-up': ThumbsUp,
  'todo-list': ListTodo,
  'trash': Trash,
  'tree': Trees,
  'triangle-alert': TriangleAlert,
  'trending-up': TrendingUp,
  'trending-up-down': TrendingUpDown,
  'unknown': CircleQuestionMark,
  'upload': CloudUpload,
  'user-plus': UserPlus,
  'video': Video,
  'waypoints': Waypoints,
  'web': Globe,
  'x': X,
  'chart-pie': ChartPie,
  'chart-column-increasing': ChartColumnIncreasing,
};
